// @ts-nocheck
import React from 'react';

const HeaderBlog = ({ text }) => {
  return (
    <>
      <section className="pb-4">
        <div className="bg-grey">
          <h1 className="font-robotoMedium py-3 text-2xl md:text-[44px] md:leading-[44px] !font-black text-[#A81414]">{ text }</h1>
        </div>
      </section>
    </>
  );
};

export default HeaderBlog;
